import React from 'react';
import Modal from '../publicComponents/modal';
import DateFormatter from '../publicComponents/formatDate';
import { message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class LatestDuaContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageURL: '',
      title: '',
      visible: false,
      copied: false,
    };
  }
  onCopy = () => {
    message.success('Link copied to clip board');
  };
  componentDidMount() {
    this._ismounted = true;
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  handleClick = (imageURL, name, e) => {
    console.log(e);
    this.setState({
      imageURL: imageURL,
      title: name,
      visible: true,
    });
  };

  setModalStatus = status => {
    this.setState({
      visible: status,
    });
  };

  render() {
    const { duas, duaCount } = this.props;
    const { imageURL = '', title = '', visible = '' } = this.state;
    const message =
      "There are no Dua's at the moment regarding this category. Please check later";
    return (
      <section>
        {imageURL && (
          <Modal
            getModalStatus={this.setModalStatus}
            title={title}
            visible={visible}
            imageURL={imageURL}
          />
        )}
        {duaCount > 0
          ? duas.map((key, count) => {
              return count === 0 ? (
                <div className='fea-video fea-dua' key={key.id}>
                  <div className='iframe-video'>
                    <a href='javascript:void(0);'>
                      <img
                        src={key.imageURL}
                        alt=''
                        style={{ width: '100%' }}
                        className='img-fluid'
                        onClick={e =>
                          this.handleClick(key.imageURL, key.name, e)
                        }
                      />
                    </a>
                  </div>
                  <div className='video-info' style={{ width: '54%' }}>
                    <h2>{key.name}</h2>
                    <p>By: {key.title}</p>
                    <div className='video-info-small'>
                      <p>
                        <img src='images/clock-icon.png' alt='' />{' '}
                        <DateFormatter custom={'true'} date={key.date} />
                      </p>
                      &nbsp;
                      <p>
                        <img src='images/folder-icon.png' alt='' />{' '}
                        {key.category}
                      </p>
                      &nbsp;
                      <CopyToClipboard text={key.imageURL} onCopy={this.onCopy}>
                        <p style={{ cursor: 'pointer' }}>
                          <img
                            src='images/share-icon.png'
                            onClick={this.handClick}
                            alt=''
                          />
                          Share
                        </p>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              );
            })
          : message}
      </section>
    );
  }
}

export default LatestDuaContent;
